export class URLHelper {
  public static appendQueryParametersToUrl(url: string, parameters: Map<string, string>): string {
    // See if our url still has a queryString
    let queryString = '';
    let queryStringHasStarted = url.indexOf('?') >= 0;

    if (parameters) {
      parameters.forEach((value, key) => {
          // Add parameter separator
          if (!queryStringHasStarted) {
            // Query string is separated from URL with "?"
            queryString += '?';
            queryStringHasStarted = true;
          } else {
            // Parameters within the query string are concatenated by "&"
            queryString += '&';
          }
          // Add parameter name
          queryString += key;
          // Add optional parameter value
          if (value != null) {
            queryString += '=' + encodeURIComponent(value);
          }
      });
      }
    return url + queryString;
  }

  public static removeUrlParameter(url: string, parameter: string) {
    let urlParts: string[] = url.split('?');

    if (urlParts.length >= 2) {
      // Get first part, and remove from array
      let urlBase: string = urlParts.shift();

      // Join it back up
      let queryString: string = urlParts.join('?');

      let prefix: string = encodeURIComponent(parameter) + '=';
      let parts: string[] = queryString.split(/[&;]/g);

      // Reverse iteration as may be destructive
      for (let i = parts.length; i-- > 0;) {
        // Idiom for string.startsWith
        if (parts[i].lastIndexOf(prefix, 0) !== -1) {
          parts.splice(i, 1);
        }
      }

      // Add back any url parameters that were not removed
      if (parts.length > 0) {
        url = urlBase + '?' + parts.join('&');
      } else {
        url = urlBase;
      }
    }
    return url;
  }

  public static appendToken(url: string, token: string): string {
    if (token) {
      let split = token.split('=');
      if (split && split.length >= 2) {
        let key = split[0];
        let value = split[1];
        let params = new Map<string, string>();
        params.set(key, value);
        let updatedUrl = URLHelper.removeUrlParameter(url, key);
        updatedUrl = URLHelper.appendQueryParametersToUrl(updatedUrl, params);
        return updatedUrl;
      } else {
        return url;
      }
    } else {
      return url;
    }
  }
}